import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'

import { OPTION_TYPES } from './constants.js'

import styles from './Option.scss'

const Option = (props) => {
    const className = classNames(styles.base, styles[`base__${props.type}`])

    return (
        <div className={className} data-tip data-for={props.tooltipId}>{props.value}</div>
    )
}

Option.TYPES = OPTION_TYPES

Option.propTypes = {
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.element,
    ]).isRequired,
    type: PropTypes.oneOf(Object.values(OPTION_TYPES)),
    tooltipId: PropTypes.string.isRequired,
}

export default Option



// WEBPACK FOOTER //
// ./components/BattleWizard/components/Option/Option.jsx